export default{
  "Mute Video": "Отключить звук видео",
  "HitPaw Online Mute Video": "HitPaw Online Отключение звука видео",
  "Fast and easy to remove sound from your video online": "Быстро и легко удалить звук из вашего видео онлайн",
  "Muting": "Отключение звука",
  "Mute Failed": "Ошибка отключения звука",
  "Mute New": "Без звука Новый"
};